<script>
import ResourceList from '@shell/components/ResourceList/index.vue';

export default {
  name:       'HarvesterResourcedList',
  components: { ResourceList },
};
</script>

<template>
  <ResourceList />
</template>
